// Byline helpers for article authors. Mirror the cover-url pattern: render an
// intentional branded placeholder / staff byline when an article has no author
// record (or no avatar) instead of a broken <img> box and a bare "By  | date".
export const AVATAR_FALLBACK = '/img/avatar-fallback.svg';
export const DEFAULT_AUTHOR_NAME = '1vX Staff';

interface AuthorLike {
  name?: string | null;
  avatar?: { url?: string | null } | null;
}

export function authorAvatar(author?: AuthorLike | null): string {
  return author?.avatar?.url || AVATAR_FALLBACK;
}

export function authorName(author?: AuthorLike | null): string {
  return author?.name || DEFAULT_AUTHOR_NAME;
}

export default authorAvatar;
